import React, {FunctionComponent, useState} from "react";
import {DemoRequestDialog} from "../demoRequest";
import {SignupDialog} from "../signupDialog/openSiteSignupDialog.component";
import {OpenSiteButton, OpenSiteButtonProps} from "../openSiteButton";
import {OpenSiteModalType} from "../../enums";

interface DialogButtonProps extends OpenSiteButtonProps {
    modalType: OpenSiteModalType
}

export const DialogButton: FunctionComponent<DialogButtonProps> = props => {
    const {text, modalType, buttonProps} = props;
    const [modalOpen, setModalOpen] = useState(false);

    const dialogContentSwitch = () => {
        switch (modalType) {
            case OpenSiteModalType.Signup:
                return <SignupDialog open={modalOpen} onClose={() => setModalOpen(false)}/>;
            default:
                return <DemoRequestDialog open={modalOpen} onClose={() => setModalOpen(false)}/>;
        }
    };

    return (
        <>
            <OpenSiteButton onClick={() => setModalOpen(true)} text={text || 'Book a Demo'} {...buttonProps}/>
            {dialogContentSwitch()}
        </>
    );
};
